<div class="expanded-panel-header orange" (click)="toggleExpand()">
  @if(participantType=='people'){
    Project Participants (CREA)
  }
  @if(participantType=='fund'){
    Fund Participants
  }
  @if(participantType=='thirdParty'){
    Project Participants (Third Party)
  }
</div>
@if(expanded){
  @for(row of rows; track $index){
    <div class="row" style="padding-left: 8px;padding-right: 8px;">
      @for(field of row; track field.key){
        <div class="col-md-4">
          <div class="row align-top" style="border-bottom: 1px solid lightgray">
            <div class="col-md-6 label">{{ field.label }}</div>
            @switch(field.key){
              @default {
                <div class="col-md-6">
                  @if(participantDetail[field.key]){
                    @for(item of participantDetail[field.key]; track $index){
                      <div class="row align-top" style="padding-left: 3px;">
                        <span>
                          <a href="{{dataFormat.formatLink(item)}}" target = '_blank' class="table-link">{{item.name}}</a>
                          @if(item.tags?.length>0){
                            <mat-icon class="participant-tag" [matTooltip]="itemTags(item)">sell</mat-icon>
                          }
                        </span>
                      </div>
                    }
                  }
                  @if(!participantDetail[field.key]){
                    <div class="row">--</div>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
}
